import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DrawerFrame from './drawer/DrawerFrame';
import DrawerHeader from './drawer/DrawerHeader';
import DrawerFooter from './drawer/DrawerFooter';
import { IcoLn } from './ActionIcons';
import { useTranslation } from 'react-i18next';

// Step-0 inspector scaffold (still mounted by AppShell for record URLs of sections without inlineRecord). On the shell frame since 46858 step 6.
export default function DrawerHost({ recordId, basePath }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [trail, setTrail] = useState([]);
  const record = useMemo(() => recordId ? { id: recordId, title: recordId } : null, [recordId]);
  const close = () => { setTrail([]); navigate(basePath); };
  const full = () => navigate(`${basePath}/${recordId}?mode=full`);
  const inspectRelated = () => { setTrail(current => [...current, recordId]); navigate(`${basePath}/${recordId}-RELATED`); };
  const back = () => { const previous = trail[trail.length - 1]; setTrail(current => current.slice(0, -1)); navigate(`${basePath}/${previous}`); };
  if (!record) return null;
  return (
    <DrawerFrame onClose={close} label={record.title}>
      <DrawerHeader eyebrow="Record · Inspector" title={record.title} meta="Inspector scaffold — one panel is replaced as you inspect related records."
        rail={<><span className="st done">{t('procFacet.open')}</span><span className="arh">→</span><span className="st now">{t('chromeUi.inspecting')}</span></>} onFullPage={full} onClose={close} />
      <div className="dr-body">
        <div className="hint">{t('chromeUi.recordDetailIsIntentionallyA')}</div>
        {trail.length > 0 && <button type="button" className="btn" onClick={back}>{t('chromeUi.backToPreviousRecord')}</button>}
      </div>
      <DrawerFooter onClose={close} secondary={<button type="button" className="btn" onClick={inspectRelated}>{t('chromeUi.inspectRelated')}</button>}
        primary={<button type="button" className="btn success" onClick={full}>{t('chromeUi.openFull')} <IcoLn name="order" /></button>} />
    </DrawerFrame>
  );
}
